import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;

@Component({
  selector: 'app-fancy-detail',
  templateUrl: './fancy-detail.component.html',
  styleUrls: ['./fancy-detail.component.css']
})
export class FancyDetailComponent extends BaseClass<any> implements OnInit {

  @Input() data: any;
  @Output() betDt = new EventEmitter();
  @Output() multiMUpdate = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  @Output() closeBet = new EventEmitter();

  modalRef?: BsModalRef;

  public fancyData: any[] = [];
  public isFancy: boolean = true;
  public tabVal: any;
  public odds: any;
  public expo: any;
  public fancyRunMarketId: any = ''
  public fancyRun: any;
  public book_name: any;
  public multiMarketIds: any[] = [];
  public betSlipData: any;

  constructor(
    public service: WebserviceService,
    public _common: CommonService,
    private modalService: BsModalService
  ) { super(); }

  ngOnInit(): void {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  multiMarketUpdate(item: any, key: any) {
    this.multiMUpdate.emit({ item: item, key: key });
  }

  openModal(template: TemplateRef<any>, key: any) {
    let cls = (key == 'book') ? 'exposureModal modal-md' : (key == 'rule') ? 'rulesModaldetail' : ''
    let id = (key == 'bets') ? 'openBets modal-md' : ''
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: cls }, { id: id })
    );
  }

  fancyRunPosition(template: TemplateRef<any>, item: any) {
    //console.log(item);
    if (this.expo[item?.market_id] && this.expo[item?.market_id][item?.selection_id]) {
      this.openModal(template, 'book');
      let tempReq = { "market_id": item.market_id }
      let req = this._common.JSON_to_URLEncoded(tempReq);
      this.getServices().Post(`${this.env.baseUrl + this.api.fancyRunPosition}`, req).subscribe(
        (res) => {
          if (res.status == true) {
            this.fancyRun = JSON.parse(res.data.position);
            this.book_name = item?.name;
          }
        },
        (err) => {
          console.log(err)
        });
    }
  }

  openBetPlace(item: any, oddsItem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string) {
    this.betDt.emit({ item: item, oddsItem: oddsItem, i: i, bet: bet, oi: oi, bkOrLy: bkOrLy, key: key })
  }

  ngOnChanges() {
    if (this.data) {
      this.fancyData = this.data?.fancyData;
      this.isFancy = this.data?.isFancy;
      this.tabVal = this.data?.tabVal;
      this.odds = this.data?.odds;
      this.expo = this.data?.expo;
      this.multiMarketIds = this.data?.multiMarketIds;
      this.betSlipData = this.data?.betSlipData;
    }
  }

  isInclude(tabVals: any, priority: any) {
    return tabVals.includes(priority);
  }

}
